import { useSelector } from "react-redux";

export default function usePermissions() {
  const channel = useSelector((state) => state.selectedChannel);
  const permissions = channel.permissions || {};

  return permissions;
}
